import { useLDFlag } from 'launchdarkly-vue-client-sdk';

const routes = [
  {
    path: '/',
    name: 'JobsList',
    meta: { requiresAuth: true, title: 'Jobs List' },
    component: () => import('@/views/JobsList.vue')
  },
  {
    path: '/code/:jobShortCode',
    name: 'JobShortCodeRedirect',
    meta: { requiresAuth: true },
    component: () => import('@/components/JobShortCodeRedirect.vue')
  },
  {
    path: '/:jobId',
    meta: { requiresAuth: true, isInternal: true },
    component: () => import('@/views/JobDetailProxy.vue'),
    children: [
      {
        path: '/:jobId',
        name: 'JobDetail',
        component: () =>
          import('@/components/JobDetail/RebateAmountAndPayment.vue')
      },
      {
        path: '/:jobId/basic-details',
        name: 'basicDetails',
        component: () => import('@/components/JobDetail/BasicDetails.vue')
      },
      {
        path: '/:jobId/energy-source-details',
        name: 'energySourcesAndUtilities',
        component: () =>
          import('@/components/JobDetail/EnergySourcesAndUtilities.vue')
      },
      {
        path: '/:jobId/services',
        name: 'services',
        component: () => import('@/components/JobDetail/Services.vue')
      },
      {
        path: '/:jobId/install-details',
        name: 'installDetails',
        component: () => import('@/components/JobDetail/InstallDetails.vue')
      },
      {
        path: '/:jobId/program-progress',
        name: 'programProgress',
        component: () => import('@/components/JobDetail/ProgramProgress.vue')
      },
      {
        path: '/:jobId/attachments',
        name: 'attachments',
        component: () => import('@/components/JobDetail/Attachments.vue')
      }
    ]
  },
  {
    path: '/contractors',
    name: 'ContractorsList',
    meta: { requiresAuth: true, title: 'Contractors List' },
    component: () => import('@/views/ContractorsList.vue')
  },
  {
    path: '/announcements',
    name: 'AnnouncementsList',
    meta: { requiresAuth: true, title: 'Announcements List' },
    component: () => import('@/views/AnnouncementsList.vue')
  },
  {
    path: '/announcements/:announcementId',
    name: 'AnnouncementDetail',
    meta: { requiresAuth: true, title: 'Announcement Details' },
    component: () => import('@/views/AnnouncementDetail.vue')
  },
  {
    path: '/programs',
    name: 'ProgramsList',
    meta: { requiresAuth: true, title: 'Programs List' },
    component: () => import('@/views/ProgramsList.vue')
  },
  {
    path: '/programs/:programId',
    name: 'ProgramDetail',
    meta: { requiresAuth: true, title: 'Program Details' },
    component: () => import('@/views/ProgramDetail.vue')
  },
  {
    path: '/program-explorer',
    meta: {
      requiresAuth: true,
      title: 'Program Explorer'
    },
    component: () => import('@/views/ProgramExplorer.vue'),
    beforeEnter: () => {
      const canViewProgramExplorer = useLDFlag('program-explorer', false);
      if (!canViewProgramExplorer.value) {
        return false;
      }
    },
    children: [
      {
        path: '/program-explorer',
        name: 'ProgramExplorer',
        component: () =>
          import('@/components/ProgramExplorer/TaskConfigurations.vue')
      },
      {
        path: '/program-explorer/task-dependencies',
        name: 'TaskDependencies',
        component: () =>
          import('@/components/ProgramExplorer/TaskDependencies.vue')
      }
    ]
  },
  {
    path: '/providers',
    name: 'EnergyProvidersList',
    meta: { requiresAuth: true, title: 'Energy Providers List' },
    component: () => import('@/views/EnergyProvidersList.vue')
  },
  {
    path: '/providers/:providerId',
    name: 'EnergyProviderDetail',
    meta: { requiresAuth: true, title: 'Energy Provider Details' },
    component: () => import('@/views/EnergyProviderDetail.vue')
  },
  {
    path: '/contractors/:contractorId',
    name: 'ContractorDetail',
    meta: { requiresAuth: true, title: 'Contractor Details' },
    component: () => import('@/views/ContractorDetail.vue')
  },
  {
    path: '/contractors/create',
    name: 'ContractorCreate',
    meta: { requiresAuth: true, title: 'New Contractor' },
    component: () => import('@/views/ContractorCreate.vue')
  },
  {
    path: '/terms_and_conditions',
    name: 'TermsAndConditionsList',
    meta: { requiresAuth: true, title: 'Terms and Conditions' },
    component: () => import('@/views/TermsAndConditionsList.vue')
  },
  {
    path: '/terms_and_conditions/:termsAndConditionsId',
    name: 'TermsAndConditionsDetail',
    meta: { requiresAuth: true, title: 'Terms and Conditions' },
    component: () => import('@/views/TermsAndConditionsDetail.vue')
  },
  {
    path: '/equipment',
    meta: { requiresAuth: true, title: 'Equipment' },
    component: () => import('@/views/Equipment.vue'),
    children: [
      {
        path: '/equipment',
        name: 'Equipment',
        component: () => import('@/components/equipment/OtherEquipment.vue')
      },
      {
        path: '/equipment/heat-pumps',
        name: 'HeatPumps',
        component: () => import('@shared/components/Equipment/HeatPumps.vue')
      },
      {
        path: '/equipment/water-heaters',
        name: 'WaterHeaters',
        component: () => import('@shared/components/Equipment/WaterHeaters.vue')
      }
    ]
  }
];

export default routes;
